<template lang="html">
  <div class="bg-loading-s1">
    <div class="inside">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
